import * as React from 'react';
import ItemCounter from '../../ItemCounter';
import './CollectionListItem.scss';
import { AssetTypeIcon } from '../../common';

export type CollectionListItemProps = {
    name: string;
    icon: keyof typeof AssetTypeIcon;
    assetCount: number;
    onClick: () => void;
    selected?: boolean;
};

const CollectionListItem: React.FunctionComponent<CollectionListItemProps> = ({
    assetCount,
    icon,
    name,
    onClick,
    selected,
}) => (
    <div className="collection-list-item">
        <span className="collection-list-item-icon" style={{ color: selected ? '#ff4f4c' : '#6b30fa' }}>
            <i className={AssetTypeIcon[icon]} />
        </span>

        <span className="collection-list-item-name" title={name} onClick={onClick}>
            {name}
        </span>

        <span className={'pull-right'}>
            <ItemCounter value={assetCount} />
        </span>
    </div>
);

CollectionListItem.displayName = 'CollectionListItem';

export default CollectionListItem;
